import { render, staticRenderFns } from "./PJCustomerCover.vue?vue&type=template&id=8bd8e412"
import script from "./PJCustomerCover.vue?vue&type=script&lang=js"
export * from "./PJCustomerCover.vue?vue&type=script&lang=js"
import style0 from "./PJCustomerCover.vue?vue&type=style&index=0&id=8bd8e412&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports